export default __webpack_public_path__ + "static/termo3-5359bd38ecc954d6776c81f66dd05414.png";